import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillOldData = function backfillOldData(_this) {
  var otherlinkInfo = _.get(_this, "oppBusiData.oldBusiData.otherlinkInfo");
  if (!_.isEmpty(otherlinkInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherlinkInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherPartnerInfo = _.get(_this.historyData, SAVE_PATH) || [];
  otherPartnerInfo = _.map(otherPartnerInfo, function (v) {
    if (v && v["ORG_NAME"]) {
      v["PARTNER_ORG_NAME"] = v["ORG_NAME"];
      v["PARTNER_ORG_NAME_DATA_SOURCE"] = v["ORG_NAME_DATA_SOURCE"];
    }
    return v;
  });

  if (!_.isEmpty(otherPartnerInfo)) {
    _this.$blMethod.parseMoudleArray(_this, _this.groupDatas[GROUP_ID][MODULE_ID], otherPartnerInfo);
  }
};

var setFeildData = function setFeildData(fieldData, fieldAction, val, filterArr) {
  _.each(fieldData, function (item) {
    if (filterArr.indexOf(item.FIELD_ID) == -1) {
      item[fieldAction] = val;
    };
  });
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  var fieldsTpl = _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].FIELDS;
  _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD_LINK = "../../../static/download/partnerInfo.xlsx";
  _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD_NAME = "合伙人信息采集表模板";
  _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD = "1";
  _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_IMPORT = "1";
  _this.groupDatas[GROUP_ID][MODULE_ID][0].MAX_LENGTH = "50";
  fields.PID_TYPE.FIELD_DICT_NAME = _.filter(fields.PID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && (item.DICT_ITEM[0] == "0" || item.DICT_ITEM[0] == "1");
  });
  fields.AREA.FIELD_TYPE = "selector";

  fields.PARTNER_NAME.FIELD_REQUIRED = "1";
  fields.PARTNER_ORG_NAME.FIELD_REQUIRED = "0";

  fieldsTpl.PID_TYPE.FIELD_DICT_NAME = _.filter(fields.PID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && (item.DICT_ITEM[0] == "0" || item.DICT_ITEM[0] == "1");
  });
  fieldsTpl.AREA.FIELD_TYPE = "selector";

  fieldsTpl.PARTNER_NAME.FIELD_REQUIRED = "1";
  fieldsTpl.PARTNER_ORG_NAME.FIELD_REQUIRED = "0";

  _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD_LINK = "../../../static/download/partnerInfo.xlsx";
  _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD_NAME = "合伙人信息采集表模板";
  _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD = "1";
  _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].MODULE_IMPORT = "1";
  _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].MAX_LENGTH = "50";
};

var setDefaultVal = function setDefaultVal(_this) {
  var fieldsTpl = _this.groupDatasTpl[GROUP_ID][MODULE_ID][0].FIELDS;
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  var custFname = _.get(_this, "historyData.BIZ_DATA.KEY_INFO.NEW_CUST_FNAME");

  if (!fields.PARTNER_ORG_NAME.DEFAULT_VALUE && custFname) {
    fields.PARTNER_ORG_NAME.DEFAULT_VALUE = custFname;
  }
  if (!fieldsTpl.PARTNER_ORG_NAME.DEFAULT_VALUE && custFname) {
    fieldsTpl.PARTNER_ORG_NAME.DEFAULT_VALUE = custFname;
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    setDefaultVal(_this);
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var partnerInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_CONTROL == "1") {
                partnerInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH]);

                if (!_.isArray(partnerInfo)) {
                  partnerInfo = [partnerInfo];
                }
                _.each(partnerInfo, function (item) {
                  item.ORG_NAME = item.PARTNER_ORG_NAME;
                });

                bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], partnerInfo);

                _.set(params, SAVE_PATH, partnerInfo);
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      var mds, i, fields;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(_this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_CONTROL == "1")) {
                _context2.next = 11;
                break;
              }

              mds = _this.groupDatas[GROUP_ID][MODULE_ID];
              i = 0;

            case 3:
              if (!(i < mds.length)) {
                _context2.next = 11;
                break;
              }

              fields = mds[i].FIELDS;

              if (!(fields.PARTNER_ORG_NAME.DEFAULT_VALUE == "" && fields.PARTNER_NAME.DEFAULT_VALUE == "")) {
                _context2.next = 8;
                break;
              }

              _this.alert("请填写合伙人信息名称！");
              return _context2.abrupt("return", false);

            case 8:
              i++;
              _context2.next = 3;
              break;

            case 11:
              return _context2.abrupt("return", true);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    setDefaultVal(_this);
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},

  CHECK_PID_TYPE: function CHECK_PID_TYPE(_this, field, fieldData, moduleObj, index, isAuto) {
    if (field.DEFAULT_VALUE == "") {
      return;
    }
    fieldData.PID_CODE.DEFAULT_VALUE = "";
    fieldData.PID_CODE.VALID_TYPE = _this.$blMethod.getIdCodeValidType(field.DEFAULT_VALUE);

    if (["00", "0J"].includes(field.DEFAULT_VALUE)) {
      fieldData["AREA"].FIELD_CONTROL = "2";
      fieldData["AREA"].DEFAULT_VALUE = "CHN";
    } else {
      fieldData["AREA"].DEFAULT_VALUE = "";
      fieldData["AREA"].FIELD_CONTROL = "0";
    }
  },

  CHECK_PID_CODE: function CHECK_PID_CODE(_this, field, fieldData, moduleObj, index, isAuto) {
    if (field.DEFAULT_VALUE == "") {
      return;
    }
    fieldData.ID_DATE.DEFAULT_VALUE && _this.$blMethod.isDisabledLongTime(_this, fieldData.PID_TYPE.DEFAULT_VALUE, fieldData.PID_CODE.DEFAULT_VALUE, fieldData.ID_DATE);
  },
  downloadModule: function downloadModule(_this, moduleId, fieldData) {},
  importModule: function importModule(_this, arr, fieldData) {
    if (arr.length <= 0) {
      _this.alert("导入数据为空");
      return;
    }
    if (arr.length > 50) {
      _this.alert("合伙人信息最多新增50个!");
      return;
    }
    var keyList = ["合伙人名称", "国籍/地区", "证件类型", "证件号码", "证件有效期截止日期", "合伙人企业类型", "承担责任方式"];
    var keyName = "";
    var isTypeErr = false;
    var errValue = [];
    for (var i = 0; i < keyList.length; i++) {
      for (var j = 0; j < arr.length; j++) {
        if (!arr[j][keyList[i]]) {
          _this.alert("第" + (j + 1) + "条数据：" + keyList[i] + "字段不能为空，请重新填写！");
          return;
        }
        if (arr[j][keyList[2]].indexOf("-") == -1) {
          isTypeErr = true;
          if (errValue.indexOf(keyList[2]) == -1) {
            errValue.push(keyList[2]);
          }
        }

        if (arr[j][keyList[1]].indexOf("-") == -1) {
          isTypeErr = true;
          if (errValue.indexOf(keyList[1]) == -1) {
            errValue.push(keyList[1]);
          }
        }

        var erterList = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.ENTERPRISE_TYPE.FIELD_DICT_NAME.map(function (val) {
          return val.DICT_ITEM + "-" + val.DICT_ITEM_NAME;
        });
        if (erterList.indexOf(arr[j][keyList[5]]) == -1) {
          isTypeErr = true;
          if (errValue.indexOf(keyList[5]) == -1) {
            errValue.push(keyList[5]);
          }
        }

        var debtBearList = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.LIAB_TYPE.FIELD_DICT_NAME.map(function (val) {
          return val.DICT_ITEM + "-" + val.DICT_ITEM_NAME;
        });
        if (debtBearList.indexOf(arr[j][keyList[6]]) == -1) {
          isTypeErr = true;
          if (errValue.indexOf(keyList[6]) == -1) {
            errValue.push(keyList[6]);
          }
        }
      }
    }
    if (isTypeErr) {
      _this.alert("您导入的模板中" + errValue + "格式错误，请重新填写！");
      isTypeErr = false;
      errValue = [];
      return;
    }
    var data = [];
    var lastIndex = _this.groupDatas[GROUP_ID][MODULE_ID].length - 1;
    _.each(_this.groupDatas[GROUP_ID][MODULE_ID][lastIndex], function (obj) {
      obj = obj.FIELDS;
    });
    var flag = false;
    _.each(_this.groupDatas[GROUP_ID][MODULE_ID][lastIndex].FIELDS, function (val, key) {
      if (val.DEFAULT_VALUE && key != "PARTNER_ORG_NAME") {
        flag = true;
        return false;
      }
    });
    _.each(_this.groupDatas[GROUP_ID][MODULE_ID], function (obj, index) {
      if (!flag && index == lastIndex) {
        return true;
      }
      obj = obj.FIELDS;
      data.push({
        PARTNER_ORG_NAME: obj.PARTNER_ORG_NAME.DEFAULT_VALUE,
        PARTNER_NAME: obj.PARTNER_NAME.DEFAULT_VALUE,
        PID_CODE: obj.PID_CODE.DEFAULT_VALUE,
        ID_DATE: obj.ID_DATE.DEFAULT_VALUE,
        ENTERPRISE_TYPE: obj.ENTERPRISE_TYPE.DEFAULT_VALUE,
        LIAB_TYPE: obj.LIAB_TYPE.DEFAULT_VALUE,
        PID_TYPE: obj.PID_TYPE.DEFAULT_VALUE,
        AREA: obj.AREA.DEFAULT_VALUE
      });
    });
    var custFname = _.get(_this, "historyData.BIZ_DATA.KEY_INFO.NEW_CUST_FNAME");
    _.each(arr, function (obj) {
      var reg = /[\/\\.]/g;
      var time = obj["证件有效期截止日期"];
      if (time === "长期") {
        time = "30001231";
      } else {
        time = obj["证件有效期截止日期"].replace(reg, "");
      }
      data.push({
        PARTNER_ORG_NAME: custFname,
        PARTNER_NAME: obj["合伙人名称"] || "",
        PID_CODE: obj["证件号码"],
        ID_DATE: time,
        ENTERPRISE_TYPE: obj["合伙人企业类型"].split("-")[0],
        LIAB_TYPE: obj["承担责任方式"].split("-")[0],
        LIAB_TYPE_TEXT: obj["承担责任方式"].split("-")[1],
        PID_TYPE: obj["证件类型"].split("-")[0],
        PID_TYPE_TEXT: obj["证件类型"].split("-")[1],
        AREA: obj["国籍/地区"].split("-")[0],
        AREA_TEXT: obj["国籍/地区"].split("-")[1],
        longTime: false });
    });
    _this.myLoading({

      loadingText: "正在回填合伙人数据&请稍候...",
      autoHide: false
    });

    _this.$blMethod.diabledFieldCheck(_this);

    _this.$blMethod.parseMoudleArray(_this, _this.groupDatas[GROUP_ID][MODULE_ID], data);
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_IMPORT = 1;
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD = 1;
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD_LINK = "../../../static/download/partnerInfo.xlsx";
    _this.groupDatas[GROUP_ID][MODULE_ID][0].MODULE_DOWNLOAD_NAME = "合伙人信息采集表模板";
    _this.groupDatas[GROUP_ID][MODULE_ID][_this.groupDatas[GROUP_ID][MODULE_ID].length - 1].MODULE_ADD = 1;
    _this.groupDatas[GROUP_ID][MODULE_ID][_this.groupDatas[GROUP_ID][MODULE_ID].length - 1].MAX_LENGTH = 50;

    setTimeout(function () {
      _this.myLoading({
        showLoading: false
      });
      _this.$blMethod.enableFieldCheck(_this);
    }, 3000);
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOther/bizOtherPartnerInfoNode.js
// module id = 204
// module chunks = 2